import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";

const SubjectForm = ({ form, onSubmit, loading }) => {
  const { t } = useTranslation();

  return (
    <Form form={form} layout="vertical" onFinish={onSubmit} disabled={loading}>
      <Form.Item
        name="title"
        label={t("subjects.crud.form.label.title")}
        rules={[
          {
            required: true,
            message: t("subjects.crud.form.error.title"),
          },
          {
            max: 100,
            message: t("subjects.crud.form.error.title.max"),
          },
        ]}
      >
        <Input />
      </Form.Item>
    </Form>
  );
};

export default SubjectForm;
